/* eslint-disable no-use-before-define */
import _ from 'lodash';

import { safeToBig } from 'shared/helpers/utils_math';
import { getProductVolumeInOunces } from 'shared/helpers/products';
import { getFlowerEquivalent } from 'shared/helpers/check-limits';
import { getTypeLimits, getLimitMessage } from '../utils';

export function isLiquidEdible(product, limits) {
  const { type, subcategory } = product;
  const { liquidEdibleTypes } = limits;
  return _.includes(liquidEdibleTypes?.subcategories, subcategory) || _.includes(liquidEdibleTypes?.categories, type);
}

export function checkLiquidEdibleVolume(cart) {
  const { state } = cart;
  const { liquidEdibleVolumeLimitInOunces } = getTypeLimits(cart);
  const totalVolumeInOunces = getTotalVolumeInOuncesForCart(cart);
  const message = getLimitMessage('liquid edibles', liquidEdibleVolumeLimitInOunces, state, 'oz');
  return totalVolumeInOunces > liquidEdibleVolumeLimitInOunces
    ? {
        total: totalVolumeInOunces,
        message,
        withinLimits: false,
      }
    : { withinLimits: true };
}

export function getTotalVolumeInOuncesForCart({ orders, limits, state, medical }) {
  return Number(
    _.reduce(
      orders,
      (previous, order) => {
        const { product, quantity } = order;
        if (!isLiquidEdible(product, limits)) {
          return previous;
        }
        const volume = getProductVolumeInOunces(product);
        const totalVolumeForOrder = safeToBig(volume).times(quantity).round(5);

        const isBritishColumbiaDispensary = state === 'BC';
        const flowerEquivalent = getFlowerEquivalent(order, medical, limits);
        const useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;

        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalVolumeForOrder);
      },
      0.0
    )
  );
}
